/**
 * Get formatted period type for VAT
 * @param {string} value - Period type value
 * @param {Function} t - Translation function
 * @returns {string} - Formatted period type
 */
export const getPeriodTypeForVat = (value, t) => {
	switch (value) {
		case "year":
			return t("home.yVAT")
		case "quarter":
			return t("home.qVAT")
		case "month":
			return t("home.mVAT")
		case "bi-annual":
			return t("taxCorePages.common.biAnnualVat")
		default:
			return value
	}
}

/**
 * Get formatted period type for EPR
 * @param {string} value - Period type value
 * @param {Function} t - Translation function
 * @returns {string} - Formatted period type
 */
export const getPeriodTypeForEPR = (value, t) => {
	switch (value) {
		case "year":
			return t("home.yEPR")
		case "quarter":
			return t("home.qEPR")
		case "month":
			return t("home.mEPR")
		default:
			return value
	}
}

/**
 * Get formatted period type for Sales Tax
 * @param {string} value - Period type value
 * @param {Function} t - Translation function
 * @returns {string} - Formatted period type
 */
export const getPeriodTypeForSalesTax = (value, t) => {
	switch (value) {
		case "year":
			return t("home.ySalexTax")
		case "quarter":
			return t("home.qSalesTax")
		case "month":
			return t("home.mSalesTax")
		case "bi-annual":
			return t("taxCorePages.common.biAnnualSalesTax")
		default:
			return value
	}
}

